module.exports = (__webpack_require__(37798))(6710);